import { createStyles } from 'antd-style'

import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'

import { EaFolderIcon } from '@eastcoal/icon/EaFolderIcon'

import { FloorBlock } from '../../../components/FloorBlock'
import { SUPPLY_DEMAND_LIST_PAGE_PATH } from '../../Content/SupplyDemand/constants/path'

import { SupplyDemandList } from './List'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: token.padding,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderRadius: 0
  },
  list: {
    padding: 1,
    overflow: 'auto',
    backgroundColor: token.colorWhite,
    boxShadow: token.boxShadowTertiary,
    borderEndStartRadius: token.borderRadiusSM,
    borderEndEndRadius: token.borderRadiusSM
  },
  form: {
    backgroundColor: token.colorWhite,
    boxShadow: token.boxShadowTertiary,
    borderRadius: token.borderRadiusSM
  }
}))

export const SupplyDemandListFloor = () => {
  const { styles } = useStyles()

  return (
    <FloorBlock
      icon={<EaFolderIcon />}
      title='供需信息'
      classNames={{
        body: styles.container
      }}
      extra={
        <NavigateButton newtab to={SUPPLY_DEMAND_LIST_PAGE_PATH} type='link'>
          更多&gt;
        </NavigateButton>
      }
    >
      <SupplyDemandList className={styles.list} />
    </FloorBlock>
  )
}
